import type { SearchResultHighlight } from '@responses/search';

import { flattenHighlights } from './flatten-highlights';

const EM_TAG_REGEX = /<em>(.*?)<\/em>/gi;

/** The exact matched terms from a result's highlight fragments (already marked up server-side), falling back to the raw search text when the result has none. */
export const getHighlightTerms = (highlights: SearchResultHighlight[] | undefined, query: string): string[] => {
  const terms = new Set<string>();

  flattenHighlights(highlights).forEach(({ text }) => {
    for (const match of text.matchAll(EM_TAG_REGEX)) {
      const term = match[1]?.trim();
      if (term) {
        terms.add(term);
      }
    }
  });

  if (terms.size > 0) {
    return [...terms];
  }

  const trimmedQuery = query.trim();
  return trimmedQuery ? [trimmedQuery] : [];
};
